<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options" [isValid]="canSave()">
  <div class="company-editor-container editor-container">
    @if(form){
    <form class="company-form admin-form" [formGroup]="form">
      <shared-ui-text-input label="FirstName" [control]="form?.firstName"></shared-ui-text-input>
      <shared-ui-text-input label="LastName" [control]="form?.lastName"></shared-ui-text-input>
      <shared-ui-text-input label="Email" [control]="form?.email"></shared-ui-text-input>
      <shared-ui-listview label="Module" [control]="form?.email" [options]="form!.modulesLst" valueName="id" displayName="name" (change)="onCheckChange($event)" checkCondition="licenseModuleID"></shared-ui-listview>
    </form>
    }
  </div>
</app-modal-wrapper>


